import BenchlingConfig from 'BenchlingConfig';

/**
 * Return whether a user is allowed to navigate to the Analysis Tool.
 */
export default function isDiscoverAnalysisEnabled(): boolean {
  return BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS;
}
